export default "__VITE_ASSET__4C1IyvAJ__"